import { track } from '@sonyged/next-history'
import Router from 'next/router'

export default track('logiq-guardian', Router.push, Router.replace)
